/**
 * MeasureSubtype enum defines the sub types of the Measure Field.
 *
 * @readonly
 * @enum {string}
 */
const MeasureSubtype = {
    CONTINUOUS: 'continuous'
};

export default MeasureSubtype;
